<template>
  <div class="sm-fly-btn-list" style="height:0">
    <button
      @click="toggleFly"
      class="sm-btn sm-fly-btn"
      :title="playing ? '暂停' : '开始'"
      type="button"
    >
      <i v-if="playing" class="el-icon-video-pause"></i>
      <i v-else class="el-icon-video-play"></i>
    </button>
    <button @click="stopFly" class="sm-btn sm-fly-btn" title="结束" type="button">
      <i class="el-icon-switch-button"></i>
    </button>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { getLonAndLat } from '@/utils'; 

export default {
  name: 'Sm3dFly',
  props: {
    points: Array
  },
  data() {
    return {
      sharedState: window.store.state,
      playing: false,
      current: 0
    };
  },
  // 监听viewer
  computed: {
    isInitViewer: function() {
      return this.sharedState.isInitViewer;
    }
  },
  methods: {
    togglePlay() {
      if (this.playing) {
        this.flyManager?.pause();
        this.playing = false;
      } else {
        this.flyManager?.play();
        this.playing = true;
      }
    },
    stop() {
      this.playing = false;
      this.flyManager?.pause();
    },
    clear() {},
    toggleFly() {
      if (this.playing) {
        this.stopFly();
      } else {
        this.fly();
      }
    },
    fly() {
      if (isEmpty(this.points)) {
        this.$message.info('请先选择路线');
        return;
      }
      if (this.points.length === 1) {
        return;
      }
      this.playing = true;
      const { viewer, Cesium } = window;
      const currentP = this.points[this.current];
      const nextP = this.points[this.current + 1];

      if (this.current === 0) {
        viewer.camera.setView({
          destination: Cesium.Cartesian3.fromDegrees(
            currentP.x,
            currentP.y,
            currentP.z
          )
        });
      }
      const stepCount = 10;
      let count = 0;
      this.setMouse(false);

      const x = nextP.x - currentP.x;
      const y = nextP.y - currentP.y;
      const z = nextP.z - currentP.z;
      const h = nextP.h - currentP.h;
      // const p = nextP.p - currentP.p;

      const flyStep = () => {
        count += 1;
        if (count === stepCount) {
          this.current += 1;
          if (this.current === this.points.length - 1) {
            this.stopFly();
            return;
          }
          this.fly();
          return;
        }

        // const pitch = 0.45;
        const destination = [
          currentP.x + (x / stepCount) * (count + 1),
          currentP.y + (y / stepCount) * (count + 1),
          currentP.z + (z / stepCount) * (count + 1)
        ];
        // const angle = getAngle({ x, y }, { x: 0, y: 1 });
        const latlon = getLonAndLat(destination[0], destination[1], 180, currentP.z < 600 ? currentP.z / 2 : currentP.z);
        console.log('fly', count, destination, latlon);
        destination[0] = latlon.lng;
        destination[1] = latlon.lat;

        viewer.camera.flyTo({
          destination: Cesium.Cartesian3.fromDegrees(...destination),
          orientation: {
            // heading: viewer.scene.camera.heading,
            // heading: Cesium.Math.toRadians(-45),
            // pitch: viewer.scene.camera.pitch,
            pitch: Cesium.Math.toRadians(-20),
            roll: 0
          },
          // duration: 0.1,
          easingFunction: Cesium.EasingFunction.LINEAR_NONE,
          complete: () => {
            if (this.playing) {
              flyStep();
            }
          }
        });
      };
      setTimeout(() => {
        flyStep();
      }, 300);
    },
    stopFly() {
      this.playing = false;
      window.viewer.camera.cancelFlight();
      this.setMouse(true);
      this.current = 0;
    },
    setMouse(enable) {
      const { scene } = window;
      scene.screenSpaceCameraController.enableRotate = enable;
      scene.screenSpaceCameraController.enableTranslate = enable;
      scene.screenSpaceCameraController.enableZoom = enable;
      scene.screenSpaceCameraController.enableTilt = enable;
      scene.screenSpaceCameraController.enableLook = enable;
    },
    syncEntities() {
      this.clearEnities();
      if (isEmpty(this.points)) {
        return;
      }
      const { Cesium, viewer } = window;

      const entityOpts = {
        id: `fly_line`,
        polyline: {
          positions: this.points.map(point =>
            Cesium.Cartesian3.fromDegrees(point.x, point.y, 0)
          ),
          width: 4,
          material: Cesium.Color.WHITE,
          clampToGround: true
        }
      };
      const entity = viewer.entities.add(entityOpts);
      this.entities[entityOpts.id] = entity;

      for (var i = 0; i < this.points.length; i++) {
        const point = this.points[i];
        const entityOpts = {
          id: `fly_line_point_${i}`,
          position: Cesium.Cartesian3.fromDegrees(point.x, point.y, 0),
          billboard: {
            width: 25,
            height: 40,
            pixelOffset: new Cesium.Cartesian2(0, -20),
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            image: require('@/asset/windfarm/marker-icon.png')
          }
        };

        const entity = viewer.entities.add(entityOpts);
        this.entities[entityOpts.id] = entity;
      }
      console.log('syncEntities', this.points, this.entities);
    },
    clearEnities() {
      const { viewer } = window;
      if (this.entities) {
        Object.keys(this.entities).forEach(key => {
          viewer.entities.removeById(key);
        });
      }
      this.entities = {};
    }
  },
  watch: {
    isInitViewer() {
      // this.init();
    },
    points() {
      this.syncEntities();
    }
  }
};
</script>
<style lang="less" scoped>
.sm-fly-btn-list {
  .sm-fly-btn {
    background: transparent;
  }
}
</style>
